import React from 'react';
import Anime, { anime } from 'react-anime';
import numberOne from '../assets/svg/17m.svg';
import numberTwo from '../assets/svg/18m.svg';
import numberThree from '../assets/svg/230m.svg';
import numberFour from '../assets/svg/32m.svg';
import './StatCircle.scss';
export default () => {

  const stats = [
    { number: 17, title: 'Over 17 million new cases of cancer are diagnosed each year worldwide.', img: numberOne },
    { number: 230, title: 'Over 230 million people around the world live with osteoarthritis.', img: numberThree },
    { number: 18, title: 'The world loses around 18 million lives to heart disease each year.', img: numberTwo},
    { number: 3.2, title: 'Approximately 3.2 million people worldwide are living with end-stage renal disease.', img: numberFour },
  ];

  const animateCircles = {
    scale: [
      { value: 0.1, duration: 0 },
      { value: 1, duration: 2000, easing: 'easeOutCirc' },
    ],
    opacity: [
      { value: 0, duration: 0 },
      { value: 1, duration: 500, easing: 'linear' },
    ],
    delay: anime.stagger(1000)
  }

  return (
    <div className="stat-circles">
      <Anime {...animateCircles} className="circle-container">
        {stats && stats.map((stat, i) => {
          return (
            <div key={i} className={`circle-inner ${i === 1 ? 'circle-inner--larger' : ''}`}>
              <Anime className={`circle-outer circle-outer-${i}`}>
                <div className="stat">
                  <span>{stat.number}m</span>
                  <div className="title">{stat.title}</div>
                </div>
              </Anime>
            </div>
          );
        })}
      </Anime>
    </div>
  );
};
